<div class="container-fluid">
  <!-- Cards de Dashboard -->
  <div class="dashboard-cards">
    <div class="dashboard-card dashboard-card-blank">
      <div class="card-blank-body"></div>
    </div>

    <div class="dashboard-card dashboard-card-blank">
      <div class="card-blank-body"></div>
    </div>

    <div class="dashboard-card dashboard-card-blank">
      <div class="card-blank-body"></div>
    </div>

    <div class="dashboard-card dashboard-card-blank">
      <div class="card-blank-body"></div>
    </div>
  </div>

  <!-- Seção de Filtros definidos -->
  <div class="filters-section">
    <div class="filters-content">
      <div class="filters-grid">
        <div class="filter-item filter-item-filtros-definidos">
          <label for="btnSelecionarFiltroDef">Filtros definidos</label>
          <div class="filtros-definidos-select-row">
            <button type="button" class="btn btn-primary btn-atualizar-filtro" (click)="atualizarFiltros()">
              Atualizar
            </button>
            <button
              type="button"
              id="btnSelecionarFiltroDef"
              class="btn btn-outline btn-selecionar-filtro-definido"
              (click)="abrirModalSelecionarFiltro(modalSelecionarFiltroDefinido)"
              title="Abrir lista de filtros salvos">
              <span class="btn-selecionar-filtro-texto">{{ textoResumoFiltroDefinido }}</span>
              <i class="fas fa-chevron-down btn-selecionar-filtro-icone" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="btn btn-outline btn-adicionar-filtro"
              (click)="irParaFiltrosDefinidos()"
              title="Criar ou editar filtros na tela Filtros definidos"
              aria-label="Ir para filtros definidos">
              +
            </button>
            <button
              type="button"
              class="btn btn-outline btn-limpar-filtro"
              [disabled]="!temFiltroAtivo"
              (click)="limparFiltros()"
              title="Remover filtro definido e limpar a busca">
              Limpar filtro
            </button>
          </div>

          <div class="condicoes-aplicadas-section" *ngIf="filtroDefinidoAtivo">
            <div class="condicoes-aplicadas-topo">
              <span class="condicoes-aplicadas-titulo">Condições</span>
              <span
                class="condicao-coluna-chip"
                *ngFor="let col of colunasUsadasNasCondicoes; trackBy: trackByColunaCondicaoResumo"
                [title]="col.abaTitulo">
                {{ col.label }}
              </span>
            </div>

            <p class="condicoes-aplicadas-resumo" *ngIf="filtroRegistrosMostraTodos">
              Todos os registros.
            </p>

            <div
              class="condicoes-aplicadas-regras"
              *ngIf="!filtroRegistrosMostraTodos && linhasCondicoesAplicadas.length > 0">
              <ng-container *ngFor="let linha of linhasCondicoesAplicadas; trackBy: trackByCondicaoAplicada">
                <span class="condicao-conector" *ngIf="linha.conector">{{ linha.conector }}</span>
                <span class="condicao-texto">{{ linha.descricao }}</span>
              </ng-container>
            </div>

            <p
              class="condicoes-aplicadas-vazio"
              *ngIf="!filtroRegistrosMostraTodos && linhasCondicoesAplicadas.length === 0">
              Sem condições configuradas.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de Clientes -->
  <div class="table-section">
    <div class="table-header">
      <h3>Lista de Clientes</h3>
      <div class="table-search">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="termoPesquisa"
          (ngModelChange)="onTermoPesquisaChange()"
          placeholder="Pesquisar clientes..."
          aria-label="Pesquisar clientes">
      </div>
    </div>
    
    <div
      class="table-container"
      [class.is-dragging]="arrastandoTabela"
      (mousedown)="iniciarArrasteTabela($event)"
      (mousemove)="moverArrasteTabela($event)"
      (mouseup)="finalizarArrasteTabela()"
      (mouseleave)="finalizarArrasteTabela()">
              <table class="table" [class.table-dinamica]="tabelaComFiltroDinamico">
          <thead>
            <tr>
              <th
                *ngFor="let coluna of colunasTabelaCache; trackBy: trackByColunaId"
                [class]="coluna.cssClass"
                [class.sortable]="coluna.ordenavel"
                (click)="coluna.ordenavel ? ordenarTabela(coluna.key) : null">
                {{ coluna.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="clientesPaginados.length === 0">
              <td [attr.colspan]="colunasTabelaCache.length" class="text-center text-muted py-4">Nenhum cliente encontrado.</td>
            </tr>
            <tr *ngFor="let cliente of clientesPaginados">
              <td
                *ngFor="let coluna of colunasTabelaCache; trackBy: trackByColunaId"
                [class]="coluna.cssClass"
                [class.celula-multiplos-valores]="colunaExibeValoresEmLista(coluna)">
                <ng-container [ngSwitch]="coluna.tipo">
                  <button
                    *ngSwitchCase="'editar'"
                    type="button"
                    class="btn btn-sm btn-outline-primary btn-editar-cliente"
                    (click)="editarCliente(cliente)">
                    Editar
                  </button>

                  <ng-container *ngSwitchCase="'pasta'">
                    <a
                      *ngIf="cliente.pastaLink; else semPastaLink"
                      [href]="cliente.pastaLink"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="pasta-link"
                      [title]="cliente.pastaLink">
                      {{ cliente.pastaApelido }}
                    </a>
                    <ng-template #semPastaLink>-</ng-template>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div
                      *ngIf="getItensValorColunaLista(cliente, coluna).length > 0; else valorCelulaSimples"
                      class="celula-valores-lista">
                      <span
                        *ngFor="let item of getItensValorColunaLista(cliente, coluna); trackBy: trackByItemLista"
                        class="celula-valor-item">
                        {{ item }}
                      </span>
                    </div>
                    <ng-template #valorCelulaSimples>
                      <span>{{ getValorColunaTabela(cliente, coluna.key) }}</span>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
    </div>

    <div class="pagination-container" *ngIf="totalItens > 0">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="pagination-info">
            <span>
              Mostrando {{ (paginaAtual - 1) * itensPorPaginaEfetivo() + 1 }} a {{ getFimItensExibidos() }} de {{ totalItens }} registros
            </span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="items-per-page">
            <label for="itensPorPaginaGestao">Itens por página:</label>
            <select
              id="itensPorPaginaGestao"
              class="form-select form-select-sm"
              [(ngModel)]="itensPorPagina"
              (change)="alterarItensPorPagina()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
          </div>
        </div>
        <div class="col-md-3" *ngIf="totalPaginas > 1">
          <nav aria-label="Navegação da página">
            <ul class="pagination pagination-sm justify-content-end mb-0">
              <li class="page-item" [class.disabled]="paginaAtual === 1">
                <a class="page-link" href="#" (click)="paginaAnterior(); $event.preventDefault()" aria-label="Página anterior">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" *ngIf="paginaAtual > 3">
                <a class="page-link" href="#" (click)="irParaPagina(1); $event.preventDefault()">1</a>
              </li>
              <li class="page-item disabled" *ngIf="paginaAtual > 4">
                <span class="page-link">...</span>
              </li>
              <li
                class="page-item"
                *ngFor="let numero of getNumerosPaginas()"
                [class.active]="numero === paginaAtual">
                <a class="page-link" href="#" (click)="irParaPagina(numero); $event.preventDefault()">{{ numero }}</a>
              </li>
              <li class="page-item disabled" *ngIf="paginaAtual < totalPaginas - 3">
                <span class="page-link">...</span>
              </li>
              <li class="page-item" *ngIf="paginaAtual < totalPaginas - 2">
                <a class="page-link" href="#" (click)="irParaPagina(totalPaginas); $event.preventDefault()">{{ totalPaginas }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
                <a class="page-link" href="#" (click)="proximaPagina(); $event.preventDefault()" aria-label="Próxima página">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <ng-template #modalSelecionarFiltroDefinido>
    <div class="modal-header">
      <h4 class="modal-title">Selecionar filtro definido</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="fecharModalSelecionarFiltro()"></button>
    </div>
    <div class="modal-body pt-0">
      <p class="text-muted small mb-3">O filtro escolhido é aplicado na listagem, respeitando a ordem de campos definida no preset.</p>
      <div class="mb-3">
        <label class="visually-hidden" for="buscaFiltroGestao">Buscar filtro</label>
        <input
          id="buscaFiltroGestao"
          type="text"
          class="form-control"
          [(ngModel)]="termoBuscaModalGestao"
          placeholder="Buscar pelo título..." />
      </div>
      <div class="list-group modal-lista-filtros-gestao">
        <button
          type="button"
          class="list-group-item list-group-item-action"
          [class.active]="!perfilSelecaoModal"
          (click)="perfilSelecaoModal = ''">
          Nenhum (sem filtro definido)
        </button>
        <button
          *ngFor="let f of filtrosSalvosFiltradosModalGestao"
          type="button"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center gap-2"
          [class.active]="isFiltroSelecionadoNoModal(f)"
          (click)="selecionarFiltroNoModal(f)">
          <span class="text-break">{{ f.titulo }}</span>
          <span class="modal-filtro-meta flex-shrink-0">
            <small class="modal-filtro-meta-item">{{ f.itens?.length || 0 }} campos</small>
            <small class="modal-filtro-meta-item" *ngIf="textoQtdCondicoesFiltro(f) as qtdCond">
              {{ qtdCond }}
            </small>
          </span>
        </button>
      </div>
      <p *ngIf="filtrosSalvosFiltradosModalGestao.length === 0" class="text-muted text-center small py-3 mb-0">
        <span *ngIf="termoBuscaModalGestao.trim()">Nenhum filtro encontrado.</span>
        <span *ngIf="!termoBuscaModalGestao.trim()">Nenhum filtro salvo. Use o botão + para criar na tela Filtros definidos.</span>
      </p>
    </div>
    <div class="modal-footer flex-wrap gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="limparFiltroDefinidoModal()">Limpar seleção</button>
      <button type="button" class="btn btn-outline-primary ms-auto" (click)="fecharModalSelecionarFiltro()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="confirmarFiltroModal()">Aplicar</button>
    </div>
  </ng-template>

  <div
    class="edicao-cliente-modal-overlay"
    *ngIf="modalEdicaoAberto"
    (click)="fecharModalEdicao()">
    <div class="edicao-cliente-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <app-cadastro-cliente
        [modoModal]="true"
        [clienteIdModal]="clienteEdicaoId"
        [clienteDataModal]="clienteEdicaoDados"
        (fecharModalSolicitado)="fecharModalEdicao()">
      </app-cadastro-cliente>
    </div>
  </div>
</div>
